import { mediaGalleryContentLoaderOptions } from '@/js/App/PdModal/mediaGalleryContentLoaderOptions'
import PdModal, { HTMLContentLoader, MediaGalleryContentLoader, NajaContentLoader } from '@peckadesign/pd-modal'

// Loaders are matched in the order of registration. `NajaContentLoader` must come last, some static modal openers
// (e.g. the conference ticket or a speaker detail) carry `data-naja-modal` as well and would be matched by it.
export default function registerContentLoadersFn(modal: PdModal): void {
	modal.registerContentLoader(new MediaGalleryContentLoader(modal, mediaGalleryContentLoaderOptions))
	modal.registerContentLoader(new HTMLContentLoader(modal))
	modal.registerContentLoader(new NajaContentLoader(modal))
}
